import Request from 'gd-request';

export default class ApiLogs {
    getLogs(companyId) {
        return new Request(this,'GET','company/{0}/system_logs'.f(companyId), {});
    }

    emailTaskReply() {
        return new Request(this,'GET','company/{0}/system_logs?logType={1}'.f(
            gd.companyId, 4
        ));
    }

    emailCreateTask() {
        return new Request(this,'GET','company/{0}/system_logs?logType={1}'.f(
            gd.companyId, 2
        ));
        // const startDate = Moment().subtract(90,'days').format("YYYY-MM-DD")
        //
        // return new Request(this,'GET','company/{0}/system_logs?logType={1}&dateStart={2}'.f(
        //     gd.companyId, 2, startDate
        // ), {});

    }
}